import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../utils/api";
import SectionShell from "./SectionShell";
import FieldGroup from "./FieldGroup";
import { inputClass } from "./styles";

const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "suspended", label: "Suspended" },
  { value: "expired", label: "Expired" },
];

const AmcManagementSection = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("active");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const loadAmc = async () => {
      try {
        const res = await api.get("/settings/amc");
        if (res.data?.success && res.data.amc) {
          setStartDate(res.data.amc.startDate || "");
          setEndDate(res.data.amc.endDate || "");
          setStatus(res.data.amc.status || "active");
        }
      } catch (err) {
        // keep silent; AMC is optional
        // console.error("Failed to load AMC details", err);
      }
    };

    loadAmc();
  }, []);

  const handleSave = async () => {
    if (isSaving) return;

    setIsSaving(true);
    try {
      const payload = {
        startDate: startDate || null,
        endDate: endDate || null,
        status,
      };

      const res = await api.post("/settings/amc", payload);
      const message =
        res?.data?.message || "AMC details updated successfully";
      toast.success(message);
    } catch (err) {
      const message =
        err?.response?.data?.message || "Failed to update AMC details";
      toast.error(message);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <SectionShell
      number="5"
      title="AMC Management"
      subtitle="Manage AMC start / end dates and current status."
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FieldGroup label="Start Date">
          <input
            type="date"
            className={inputClass}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </FieldGroup>
        <FieldGroup label="End Date">
          <input
            type="date"
            className={inputClass}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </FieldGroup>
        <FieldGroup label="Status">
          <select
            className={inputClass}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            {statusOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </FieldGroup>
      </div>
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={handleSave}
          disabled={isSaving}
          className={`w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200 ${
            isSaving ? "opacity-70 cursor-not-allowed" : ""
          }`}
        >
          {isSaving ? "Saving AMC..." : "Save AMC"}
        </button>
      </div>
    </SectionShell>
  );
};

export default AmcManagementSection;

